module.exports = __webpack_public_path__ + "static/media/hammer-and-pick_2692.2bb182c9.png";